
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ScoreboardDisplay } from '@/components/scoreboard/ScoreboardDisplay';
import { useScoreboardState } from '@/hooks/useScoreboardState';

export default function ScoreboardPage() {
  const { number } = useParams<{ number: string }>();
  
  const { 
    teamAScore,
    teamBScore,
    teamAHits,
    teamAErrors,
    teamBHits,
    teamBErrors,
    balls,
    strikes,
    outs,
    count,
    isTopInning,
    baseRunners,
    teamAName,
    teamAPrimaryColor,
    teamASecondaryColor,
    teamALogoUrl,
    teamBName,
    teamBPrimaryColor,
    teamBSecondaryColor,
    teamBLogoUrl,
  } = useScoreboardState(number);
  
  useEffect(() => {
    // Hide cursor in fullscreen mode
    document.body.style.cursor = 'none';
    
    // Set background color to black for the entire page
    document.body.style.backgroundColor = 'black';
    
    return () => {
      document.body.style.cursor = 'auto';
      document.body.style.backgroundColor = '';
    };
  }, []);
  
  if (!number) {
    return (
      <div className="min-h-screen bg-transparent text-white flex items-center justify-center">
        <h1 className="text-2xl">Error: No kit number provided</h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-transparent">
      <div 
        className="fixed bottom-[12vh] right-[6vw] w-[23.5vw] scale-[0.94] translate-x-[4%] -translate-y-[4%]"
      >
        <ScoreboardDisplay 
          teamAScore={teamAScore}
          teamBScore={teamBScore}
          teamAHits={teamAHits}
          teamAErrors={teamAErrors}
          teamBHits={teamBHits}
          teamBErrors={teamBErrors}
          balls={balls}
          strikes={strikes}
          outs={outs}
          count={count}
          isTopInning={isTopInning}
          baseRunners={baseRunners}
          teamAName={teamAName}
          teamAPrimaryColor={teamAPrimaryColor}
          teamASecondaryColor={teamASecondaryColor}
          teamALogoUrl={teamALogoUrl}
          teamBName={teamBName}
          teamBPrimaryColor={teamBPrimaryColor}
          teamBSecondaryColor={teamBSecondaryColor}
          teamBLogoUrl={teamBLogoUrl}
          textSizeReduced={true}
        />
      </div>
    </div>
  );
}
